import axios from 'axios';
import BaseApi from './base';
import {
    GET_CATEGORIES,
    GET_CATEGORY,
    GET_COURSE,
    GET_EXAM,
    SAVE_EXAM,
    BEGIN_EDUCATION,
    GET_GOOD_CALLS
} from '../constants/api';

export default class extends BaseApi {
    static getCategories() {
        return axios.get(GET_CATEGORIES);
    }

    static getCategoryById(id, page = 1, status = null) {
        let statusResult = status ? `&status=${status}` : '';
        return axios.get(GET_CATEGORY + id + `?page=${page}${statusResult}`)
    }

    static getCourseById(id, item = 1) {
        return axios.get(GET_COURSE + id + `?item=${item}`);
    }

    static getExam(id) {
        return axios.get(GET_EXAM + id);
    }

    static saveExam(data) {
        return axios.post(SAVE_EXAM, data);
    }

    static beginEducation(id) {
        return axios.get(BEGIN_EDUCATION + id);
    }

    static getGoodCalls() {
        return axios.get(GET_GOOD_CALLS);
    }
}